<template>
	<div>
		<div class="data33">
			<div class="data33Til">{{list.data.menuTitle}}</div>
			<div class="data33Cen">
				<div v-for="(item,index) in list.data.desc" :key="index">{{item.text}}</div>
			</div>
			<div class="data33Box">
				<div class="swiper-data33" :class="`swiper-data33${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide swiper-slide33" v-for="(item,index) in list.data.content" :key="index">
							<div class="data33For">
								<div class="data33ForImg">
									<img :src='item.cover' />
								</div>
								<div class="data33ForName">
									{{item.title}}
								</div>
							</div>
						</div>
					</div>
					<template v-if="!headerShow">
						<div class="swiper-hexin-prev"  :style="{
							left:`30px`,
							display:qhShow?activeIndex==0?'none':'block':'none'
						}" @click="prev()">
							<img src="@/assets/index/hxz.png" />
						</div>
						<div class="swiper-hexin-next" :style="{
							right:`30px`,
							display:qhShow?activeIndex==list.data.content.length-1?'none':'block':'none'
						}" @click="next()">
							<img src="@/assets/index/hxy.png" />
						</div>
					</template>
				</div>
				<!-- <div class="data33For" v-for="(item,index) in list.data.content" :key="index">
				<div class="data33ForImg">
					<img :src='item.cover' />
				</div>
				<div class="data33ForName">
					{{item.title}}
				</div>
			</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				qhShow:true,
				activeIndex: 0,
				prev:'none',
				next:'block',
				// list:[
				// 	{
				// 		img:require('@/assets/product/page8/ledgy.png'),
				// 		name:'便于传输安装'
				// 	},
				// 	{
				// 		img:require('@/assets/product/page8/ledgy.png'),
				// 		name:'便于不同场景下使用'
				// 	},
				// ]
			}
		},
		mounted() {
			let t=this;
			let name = '.swiper-data33' + this.list.index;
			const mySwiper = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				// 自动播放
				autoplay: false,
				widch: 580,
				slidesPerView: 'auto', // 每屏显示3个滑块
				spaceBetween: 40,
				allowTouchMove: this.list.data.content.length > 1 ? true : false,
				navigation: {
					prevEl: ".swiper-hexin-prev",
					nextEl: ".swiper-hexin-next",
				},
				on: {
					slideChangeTransitionStart(e) {
						t.activeIndex = this.activeIndex;
					},

				},
			});
			this.$nextTick(function(){
				if(this.list.data.content.length<2){
					this.qhShow=false
				}
			})
		},
		methods: {
			next(){
				console.log("right")
				let t=this;
				if(t.activeIndex==t.list.data.content.length-1){
					t.activeIndex = 0;
				}else{
					t.activeIndex++;
				}
				// this.mySwiper.slideNext()
			},
			prev(){
				let t=this;
				if(t.activeIndex==0){
					t.activeIndex = t.list.data.content.length-1;
				}else{
					t.activeIndex--;
				}
				console.log("left")
				// this.mySwiper.slidePrev()
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data33 {
		width: 1200px;
		margin: 0 auto;
		padding-bottom: 150px;

		.data33Til {
			font-size: 45px;
			
			font-weight: bold;
			color: #000000;
			margin-bottom: 40px;
		}

		.data33Cen {
			font-size: 18px;
			
			font-weight: 300;
			color: #000000;
			margin-bottom: 40px;

			>div {
				white-space: pre-line;
			}
		}

		.data33Box {
			display: flex;

			.data33For:not(:last-child) {
				margin-right: 40px;
			}

			.data33For {
				width: 580px;

				.data33ForImg {
					width: 580px;
					height: 400px;
					margin-bottom: 35px;
					overflow: hidden;

					img {
						width: 580px;
						height: 400px;
						object-fit: cover;
					}
				}

				.data33ForName {
					font-size: 26px;
					
					font-weight: 400;
					color: #000000;
					white-space: pre-line;
				}
			}
		}
	}

	.swiper-data33 {
		overflow: hidden;
		position: relative;
		.swiper-hexin-prev{
			display: none;
		}
		.swiper-hexin-next{
			display: none;
		}
		.swiper-slide33 {
			width: 580px;
		}
	}

	@media screen and (max-width:1200px) {
		.data33 {
			width: 100% !important;
			padding:0 30px 30px !important;
			box-sizing: border-box;
			.data33Til {
				font-size: 24px !important;
				margin-bottom:20px !important;
			}
			.data33Cen{
				font-size: 14px !important;
				margin-bottom: 20px !important;
			}
			.swiper-slide33{
				width: 100% !important;
			}
			.data33Box{
				
				.data33For {
					max-width: 100% !important;
					
					.data33ForImg {
						width: 100% !important;
						height: auto !important;
						margin-bottom: 20px !important;
						img {
							width: 100% !important;
							height: auto !important;
							object-fit: contain !important;
						}
					}
					.data33ForName{
						font-size: 14px !important;
					}
				}
			}
		}
		.swiper-data33{
			.swiper-hexin-prev{
				display: block;
			}
			.swiper-hexin-next{
				display: block;
			}
			.swiper-hexin-prev {
				position: absolute;
				top: 50%;
				left: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 100%;
				transform: translateY(-50%);
				transition: all 0.3s ease;
			}
			
			.swiper-hexin-next {
				transform: translateY(-50%);
				position: absolute;
				top: 50%;
				right: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				border-radius: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: all 0.3s ease;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			}
		}
	}
</style>